import React from "react";
import { Routes, Route } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";

import { Layout } from "./component/common/layout/layout";
import { RequireAuth } from "./component/common/require-auth/require-auth";

import { Welcome } from "./component/page/welcome/welcome";
import { Login } from "./component/page/login/login";
import { Templates } from "./component/page/templates/templates";
import { NewTemplate } from "./component/page/edit-template/new-template";
import { EditTemplate } from "./component/page/edit-template/edit-template";
import { ServiceWorksheets } from "./component/page/service-worksheets/service-worksheets";
import { NewServiceWorksheet } from "./component/page/edit-service-worksheet/new-service-worksheet";
import { EditServiceWorksheet } from "./component/page/edit-service-worksheet/edit-service-worksheet";
import { OnSiteServiceWorksheets } from "./component/page/on-site-service-worksheets/on-site-service-worksheets";
import { ServiceHistory } from "./component/page/service-history/service-history";
import { Emails } from "./component/page/emails/emails";
import { MobileApps } from "./component/page/mobile-apps/mobile-apps";
import { ScheduledJobs } from "./component/page/scheduled-jobs/scheduled-jobs";
import { Alarms } from "./component/page/alarms/alarms";
import { NotFound } from "./component/page/not-found/not-found";

export const App = () => (
  <div className="App">
    <AuthenticatedTemplate>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route element={<RequireAuth allowedRoles={[]} />}>
            <Route path="/" element={<Welcome />} />
          </Route>

          <Route
            element={
              <RequireAuth
                allowedRoles={[`${process.env.REACT_APP_ADMIN_ROLE}`]}
              />
            }
          >
            <Route path="/templates" element={<Templates />} />
            <Route path="/newtemplate" element={<NewTemplate />} />
            <Route path="/edittemplate/:id" element={<EditTemplate />} />
            <Route path="/serviceworksheets" element={<ServiceWorksheets />} />
            <Route
              path="/newserviceworksheet"
              element={<NewServiceWorksheet />}
            />
            <Route
              path="/editserviceworksheet/:id"
              element={<EditServiceWorksheet />}
            />
            <Route
              path="/onsiteserviceworksheets"
              element={<OnSiteServiceWorksheets />}
            />
            <Route path="/servicehistory" element={<ServiceHistory />} />
            <Route path="/emails" element={<Emails />} />
            <Route path="/alarms" element={<Alarms />} />
          </Route>

          <Route
            element={
              <RequireAuth
                allowedRoles={[`${process.env.REACT_APP_SUPER_ADMIN_ROLE}`]}
              />
            }
          >
            <Route path="/apps" element={<MobileApps />} />
            <Route path="/scheduledjobs" element={<ScheduledJobs />} />
          </Route>

          {/* catch all */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </AuthenticatedTemplate>

    <UnauthenticatedTemplate>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route exact path="/" element={<Login />} />

          <Route path="/templates" element={<Login requiredLogin={true} />} />
          <Route path="/newtemplate" element={<Login requiredLogin={true} />} />
          <Route
            path="/edittemplate/:id"
            element={<Login requiredLogin={true} />}
          />
          <Route
            path="/serviceworksheets"
            element={<Login requiredLogin={true} />}
          />
          <Route
            path="/newserviceworksheet"
            element={<Login requiredLogin={true} />}
          />
          <Route
            path="/editserviceworksheet/:id"
            element={<Login requiredLogin={true} />}
          />
          <Route
            path="/onsiteserviceworksheets"
            element={<Login requiredLogin={true} />}
          />
          <Route
            path="/servicehistory"
            element={<Login requiredLogin={true} />}
          />
          <Route path="/emails" element={<Login requiredLogin={true} />} />
          <Route path="/alarms" element={<Login requiredLogin={true} />} />
          <Route path="/apps" element={<Login requiredLogin={true} />} />
          <Route
            path="/scheduledjobs"
            element={<Login requiredLogin={true} />}
          />

          {/* catch all */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </UnauthenticatedTemplate>
  </div>
);
